import { email, maxLength, required } from 'vuelidate/lib/validators';

export default {
  email: {
    required,
    email,
    maxLength: maxLength(100)
  }
};
